import wizTableButtons from "./index.vue";

wizTableButtons.install = (Vue) => {
  Vue.component(wizTableButtons.name, wizTableButtons);
};

export default wizTableButtons;
